import { useRequest } from "ahooks";
import { request } from "../../request";

// export async function request(
//   url: string,
//   params: Omit<Parameters<typeof fetch>[1], "body"> & {
//     body?: any;
//     /**
//      * @name isSuccess 判断是否 resolve
//      * @param resData json序列化后的data
//      * @description 返回true拿到 resolve json，否则返回 reject
//      */
//     isSuccess?(resData: any): boolean;
//   },
// ) {
//   const Authorization = `Bearer ${sessionStorage.getItem("ZeitroA")}`;
//   const res = await fetch(url, {
//     ...params,
//     headers: { Authorization, ...(params.headers || {}) },
//     body: params.body ? JSON.stringify(params.body) : undefined,
//   });
//   const data = await res.json();
//   if (params.isSuccess) {
//     return params.isSuccess(data)
//       ? Promise.resolve(data)
//       : Promise.reject(data);
//   } else {
//     return Promise.resolve(data);
//   }
// }

export interface TypeLenderContactPerson
  extends Record<
    | "id"
    | "last_name"
    | "first_name"
    | "role"
    | "email"
    | "phone_number"
    | "lender_id"
    | "lender_name"
    | "created_at",
    string
  > {
  /**
   * @param role 用户角色、岗位
   */
  role: string;
  /**
   * @param is_default 默认用户不能编辑、删除
   */
  is_default: boolean;
}

interface TypeUseContactData {
  MAP_LENDER_CONTACT: Record<string, TypeLenderContactPerson[]>;
  CONTACTS: TypeLenderContactPerson[];
}

/**
 * @name useContact 对“Contact”实现增删改
 */
export function useContact() {
  const { data, run, loading } = useRequest(async () => {
    const res = await request(`/api/v1/mortgagegpt/getLenderContacts`);
    const data = res?.contacts as TypeLenderContactPerson[];
    if (!data?.length) return;
    const MAP_LENDER_CONTACT = {}; // 根据lender进行分组

    for (const val of data) {
      if (MAP_LENDER_CONTACT[val.lender_id]) {
        MAP_LENDER_CONTACT[val.lender_id].push(val);
      } else {
        MAP_LENDER_CONTACT[val.lender_id] = [val];
      }
    }
    return {
      MAP_LENDER_CONTACT,
      CONTACTS: res.contacts || [],
    };
  });

  return {
    run,
    data: (data || {
      MAP_LENDER_CONTACT: {},
      CONTACTS: [],
    }) as TypeUseContactData,
    loading,
  };
}

export type TypeUseContact = ReturnType<typeof useContact>;
